import { useQuery } from 'react-query';

import { SearchEntitiesResponse, searchEntities } from '@utils/backend-api/search';

export const SEARCH_ENTITIES_KEY = 'SEARCH_ENTITIES_KEY';

export interface UseSearchEntitiesParams {
  query: string;
}

export interface UseSearchEntitiesReturn {
  data?: SearchEntitiesResponse;
}

export default function useSearchEntities({
  query,
}: UseSearchEntitiesParams): UseSearchEntitiesReturn {
  return useQuery<SearchEntitiesResponse>(
    [SEARCH_ENTITIES_KEY, query],
    () => {
      return searchEntities({ query });
    },
    {
      enabled: !!query,
      keepPreviousData: false,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
}
